import { render, staticRenderFns } from "./LabelPicker.vue?vue&type=template&id=299635e5&scoped=true&"
import script from "./LabelPicker.vue?vue&type=script&lang=js&"
export * from "./LabelPicker.vue?vue&type=script&lang=js&"
import style0 from "./LabelPicker.vue?vue&type=style&index=0&id=299635e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299635e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VBtn,VChip,VIcon,VListItemContent,VListItemTitle})
